import { Card, Accordion, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HELP_FAQ_IDS } from '../../config/helpPage.config';

const FAQ_ICONS: Record<string, string> = {
  permission: 'fa-user-shield text-danger',
  csrf: 'fa-cookie-bite text-danger',
  auth: 'fa-user-lock text-danger',
  excel: 'fa-file-excel text-danger',
  reservation_email: 'fa-envelope-open-text text-danger',
};

export default function HelpFaqSection() {
  const { t } = useTranslation();

  return (
    <Card className="mb-4">
      <Card.Header>
        <h5 className="mb-0">
          <i className="fas fa-exclamation-triangle me-2" />
          {t('help.faq_title')}
        </h5>
      </Card.Header>
      <Card.Body>
        <Accordion flush>
          {HELP_FAQ_IDS.map((faqId, index) => {
            const exampleKey = `help.faq.${faqId}.example`;
            const exampleRaw = t(exampleKey);
            const example = exampleRaw !== exampleKey ? exampleRaw : '';
            const solutionsKey = `help.faq.${faqId}.solutions`;
            const solutions = t(solutionsKey, { returnObjects: true });
            const solutionList = Array.isArray(solutions) ? (solutions as string[]) : [];

            return (
              <Accordion.Item eventKey={String(index)} key={faqId}>
                <Accordion.Header>
                  <i className={`fas ${FAQ_ICONS[faqId] ?? 'fa-question-circle'} me-2`} />
                  {t(`help.faq.${faqId}.title`)}
                </Accordion.Header>
                <Accordion.Body>
                  {example && (
                    <Alert variant="warning" className="mb-3">
                      <strong>{t('help.faq_error_example_label')}</strong>
                      <br />
                      <code>{example}</code>
                    </Alert>
                  )}
                  {faqId === 'auth' && (
                    <p className="mb-3">
                      {t('help.faq.auth.password_hint_prefix')}
                      <Link to="/password-reset">{t('help.faq.auth.password_reset_link')}</Link>
                      {t('help.faq.auth.password_hint_suffix')}
                    </p>
                  )}
                  <h6>{t('help.faq_solution_label')}</h6>
                  <ol>
                    {solutionList.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ol>
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </Card.Body>
    </Card>
  );
}
